var _defs, _g, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_filter_active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3.05 3.18h38.9v38.64H3.05z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_filter_active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_filter_active_svg__cls-3",
    d: "M40.88 4.32L27.71 17.55a2.57 2.57 0 00-.65 1.58v15.78a1.81 1.81 0 01-.79 1.4l-7.54 4.59c-.44.27-.79.07-.79-.44V19.13a2.57 2.57 0 00-.65-1.58L4.12 4.32c-.36-.36-.24-.65.27-.65h36.22c.51 0 .63.29.27.65M41 3.18H4c-1 0-1.27.58-.55 1.31L15.9 17a5.21 5.21 0 011.29 3.16v20.52c0 1 .72 1.43 1.6.92l7.42-4.28a3.54 3.54 0 001.6-2.77V20.19A5.21 5.21 0 0129.1 17L41.54 4.49c.72-.73.47-1.31-.55-1.31"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 9,
    r: 8.87,
    fill: "#c01774"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.87 9l3.37-4.8h.48l-3.6 5.1 3.74 5.32h-.48l-3.51-5-3.52 5h-.46l3.74-5.32L32 4.18h.49z",
    fill: "#fff"
  })));
}

export default SvgIconFilterActive;